import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {
  ADDRESS_IMPORT_TYPE_CITY,
  ADDRESS_IMPORT_TYPE_COMMUNE,
  ADDRESS_IMPORT_TYPE_DISTRICT,
  ADDRESS_IMPORT_TYPE_STREET
} from "../../../shared/services/dict.service";

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss']
})
export class AddressFormComponent implements OnInit {
  @Input() title: string;
  @Input() addressForm: FormGroup;
  @Input() simple = false;
  @Input() required = true;
  @Input() requirePzuData = false;
  @Input() foreignActivitiesType = false;

  readonly ADDRESS_IMPORT_TYPE_COMMUNE = ADDRESS_IMPORT_TYPE_COMMUNE;
  readonly ADDRESS_IMPORT_TYPE_DISTRICT = ADDRESS_IMPORT_TYPE_DISTRICT;
  readonly ADDRESS_IMPORT_TYPE_STREET = ADDRESS_IMPORT_TYPE_STREET;

  stateControl: FormControl;
  cityControl: FormControl;
  streetControl: FormControl;
  communeControl: FormControl;
  districtControl: FormControl;
  postCityControl: FormControl;

  constructor(
  ) { }

  ngOnInit(): void {
    this.stateControl = this.addressForm.get('state') as FormControl;
    this.cityControl = this.addressForm.get('city') as FormControl;
    this.streetControl = this.addressForm.get('street') as FormControl;
    this.communeControl = this.addressForm.get('commune') as FormControl;
    this.districtControl = this.addressForm.get('district') as FormControl;
    this.postCityControl = this.addressForm.get('postCity') as FormControl;
  }

}
